module.exports = __webpack_public_path__ + "static/media/WtbProds.b3a1a424.jpg";